import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getReplacmentTeamList } from "../../../slices/UserSlice";
import SelectBox from '../SelectBox';
export function ReplaceUser({params}){
    const dispatch = useDispatch();
    const {
            replacmentTeamLsit: teamList
        } = useSelector( (state) =>  state.users );
    const {
        userId
    } = params;
    const [propsData, setPropsData] = useState({}); 
    const [teamReplacmentList, setTeamReplacmentList] = useState([]);
    const [selectedMember, setSelectedMember] = useState('');

    useEffect( () => {
        setPropsData({
            fullName: params.fullName
        });
    }, [params])

    useEffect( () => {
        dispatch(getReplacmentTeamList({userId}))
    }, [dispatch])

    useEffect( () => {
        const replacement = teamList.map( (item) => { return {label:  `${item.name}  ${item.empCode?`(${item.empCode})`:''}`, value: item._id} } )
        replacement.unshift({value:'', label: 'Select Team Member'})
        setTeamReplacmentList(replacement);

    }, [teamList])

    const submitChanged = function () {
        params?.onSubmit(selectedMember)   
    }

    return (
        <>
            <div className="col-sm-12 p-3">
                    <div className="form-group row">
                        <label htmlFor="card-number" className="col-sm-4 col-form-label">
                            <b>Current Team Member</b>
                        </label> 
                        <div className="col-sm-8">
                            <input type="text" className="form-control" value={propsData?.fullName || ''}  disabled/>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="businessEntityBranchId" className="col-sm-4 col-form-label">
                            <b>Team Members</b>
                        </label>
                        <div className="col-sm-8">
                        <SelectBox 
                            isClearable={true}
                            options={teamReplacmentList} 
                            closeMenuOnSelect={false}
                            onChange={(e) => setSelectedMember(e.value)}
                        />
                        </div>
                    </div>
                    <div className="form-group text-center">
                        <button onClick={submitChanged} disabled={!selectedMember} className="btn btn-lg btn-block btn-success">Confirm</button> 
                    </div>
            </div >
        </>
    );
}